import * as actionTypes from '../redux/actionTypes';

const initialState = {
  outboundRoutePoints: [],
  inboundRoutePoints: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PARTICIPANT_ROUTE_LOADED:
      return { ...state, ...action.data };
    default:
      return state;
  }
};
